import React, { Component } from 'react';
import WreckAPI from '../lib/wreck_api.js';
import LoginForm from '../components/login_form.js';

class Login extends Component {
  constructor() {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();
    const formData = new FormData(event.target);
    const loginData = {email: formData.get('email')}

    WreckAPI.login(loginData)
      .then((data) => {
        console.log("Login Successful")
      })
      .catch((data) => {
        console.error(data)
        alert(JSON.stringify(data.error))
      })
  }

  render() {
    const LayoutWrapper = this.props.layout

    return (
      <LayoutWrapper>
        <div className="page">
          <h2>Log in to your wreckfinder account</h2>
          <h6>
            <strong>We use a password-less login.</strong> Simply enter your wreckfinder account
            email address below and if you have never logged in on this device before,
            we will send you an email with a verification link to gain access.
          </h6>
          <hr />
          <LoginForm handleSubmit={this.handleSubmit} />
        </div>
      </LayoutWrapper>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/pages/login.js